module.exports = __webpack_public_path__ + "static/img/schedule.2d3ecb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2023/schedule.jpg
// module id = HNBs
// module chunks = 4